<main class="flex flex-col items-center">
  <div class="breadcrumbs-container flex justify-start gap-1 mt-10">
    <div class="root">
      <span
        routerLink="/home"
        class="root text-regular text-charcoal-800"
      >
        Homepage
      </span>
      <span class="text-regular text-charcoal-800"> /</span>
    </div>

    <div class="sub-root">
      <span class="text-regular text-charcoal-800" [routerLink]="middleBreadcrumbLink">{{ middleBreadcrumbText }}</span>
      <span class="text-regular text-charcoal-800"> /</span>
    </div>

    <img
      routerLink="/home"
      class="arrow-left-container"
      src="assets/icons/arrow-left.svg"
      alt="arrow-left"
    >
    <span class="text-regular text-blue-700">{{ breadcrumbText }}</span>
  </div>

  <section class="title-section flex items-center flex-col mt-12">
    <h1 class="text-display-md text-bold text-charcoal-800 m-0" style="text-align: center;">
      Selecione uma localidade
    </h1>

    <p class="title-section-text text-heading-md text-regular text-charcoal-800 w-1/2 mt-2" style="text-align: center;">
      {{ subtitleText }}
    </p>
  </section>

  <!-- Container principal com background -->
  <section class="main-content-container">
    <!-- Imagem de fundo separada -->
    <div class="background-wrapper">
      <img class="background-circles" src="assets/ilustrations/circles-background-4.png" alt="background-circles">
    </div>

    <!-- Container dos dropdowns e botão -->
    <div class="content-wrapper">
      <form [formGroup]="formularioLocalizacao" class="localidades-buttons-container flex flex-col gap-3">
        <!-- País (Brasil - fixo) -->
        <div class="country-button-container flex items-center">
          <img class="country-location-icon" src="assets/icons/pin.svg" alt="pin">
          <div class="country-input flex-1">
            Brasil
          </div>
        </div>

        <!-- Estado -->
        <div class="state-button-container flex items-center" [class.has-text]="estadoTemTexto">
          <img class="state-location-icon" src="assets/icons/pin.svg" alt="pin">
          <div class="state-input flex-1">
            {{ estadoSelecionadoTexto }}
          </div>
          <img
            class="state-arrow-icon"
            src="assets/icons/down.svg"
            alt="arrow-down"
            *ngIf="!carregandoEstados"
          >
          <mat-spinner
            *ngIf="carregandoEstados"
            diameter="16"
          ></mat-spinner>

          <!-- Input invisível -->
          <input
            #inputEstadoAutocomplete
            type="text"
            class="autocomplete-input-overlay"
            [formControl]="estadoAutocompleteControl"
            [matAutocomplete]="autoEstado"
            [disabled]="carregandoEstados"
            (focus)="estadoAutocompleteControl.setValue('')">
          <mat-autocomplete
            #autoEstado="matAutocomplete"
            [displayWith]="displayEstado"
            (optionSelected)="onEstadoSelecionado($event.option.value)"
            panelClass="localidades-select-panel">
            <mat-option [value]="null">
              <em>Nível Nacional</em>
            </mat-option>
            <mat-option
              *ngFor="let estado of estadosFiltrados$ | async"
              [value]="estado">
              {{ estado.label }}
            </mat-option>
          </mat-autocomplete>
        </div>

        <!-- Cidade -->
        <div class="city-button-container flex items-center"
             [class.disabled]="!podeSelecionarCidade"
             [class.has-text]="cidadeTemTexto">
          <img class="city-location-icon" src="assets/icons/pin.svg" alt="pin">
          <div class="city-input flex-1">
            {{ cidadeSelecionadaTexto }}
          </div>
          <img
            class="city-arrow-icon"
            src="assets/icons/down.svg"
            alt="arrow-down"
            *ngIf="podeSelecionarCidade && !carregandoCidades"
          >
          <mat-spinner
            *ngIf="carregandoCidades"
            diameter="16"
          ></mat-spinner>

          <!-- Input invisível -->
          <input
            #inputCidadeAutocomplete
            type="text"
            class="autocomplete-input-overlay"
            [formControl]="cidadeAutocompleteControl"
            [matAutocomplete]="autoCidade"
            [disabled]="!podeSelecionarCidade || carregandoCidades"
            (focus)="cidadeAutocompleteControl.setValue('')">
          <mat-autocomplete
            #autoCidade="matAutocomplete"
            [displayWith]="displayCidade"
            (optionSelected)="onCidadeSelecionada($event.option.value)"
            panelClass="localidades-select-panel">
            <mat-option [value]="null">
              <em>Todo o estado</em>
            </mat-option>
            <mat-option
              *ngFor="let cidade of cidadesFiltradas$ | async"
              [value]="cidade">
              {{ cidade.label }}
            </mat-option>
          </mat-autocomplete>
        </div>

        <!-- Escola (apenas em /filtrar-escolas) -->
        <div *ngIf="mostrarSeletorEscolas"
             class="school-button-container flex items-center"
             [class.disabled]="!podeSelecionarEscola"
             [class.has-text]="escolaTemTexto">
          <img class="school-location-icon" src="assets/icons/pin.svg" alt="pin">
          <div class="school-input flex-1">
            {{ escolaSelecionadaTexto }}
          </div>
          <img
            class="school-arrow-icon"
            src="assets/icons/down.svg"
            alt="arrow-down"
            *ngIf="podeSelecionarEscola && !carregandoEscolas"
          >
          <mat-spinner
            *ngIf="carregandoEscolas"
            diameter="16"
          ></mat-spinner>

          <!-- Input invisível -->
          <input
            #inputEscolaAutocomplete
            type="text"
            class="autocomplete-input-overlay"
            [formControl]="escolaAutocompleteControl"
            [matAutocomplete]="autoEscola"
            [disabled]="!podeSelecionarEscola || carregandoEscolas"
            (focus)="escolaAutocompleteControl.setValue('')">
          <mat-autocomplete
            #autoEscola="matAutocomplete"
            [displayWith]="displayEscola"
            (optionSelected)="onEscolaSelecionada($event.option.value)"
            panelClass="localidades-select-panel">
            <mat-option [value]="null">
              <em>Todas as escolas do município</em>
            </mat-option>
            <mat-option
              *ngFor="let escola of escolasFiltradas$ | async"
              [value]="escola">
              {{ escola.nomeInstituicao }}
            </mat-option>
          </mat-autocomplete>
        </div>

        <!-- Plano Educacional -->
        <div class="education-button-container flex items-center"
             [class.disabled]="!podeSelecionarPlanoEducacional"
             (click)="abrirSelectPlanoEducacional()">
          <img class="education-location-icon" src="assets/icons/split-square.svg" alt="split-square">
          <div class="education-input flex-1">
            {{ planoEducacionalSelecionadoTexto }}
          </div>
          <img
            class="education-arrow-icon"
            src="assets/icons/down.svg"
            alt="arrow-down"
            *ngIf="podeSelecionarPlanoEducacional"
          >
        </div>

        <!-- Selects ocultos do Material para funcionalidade -->
        <div class="hidden-selects">
          <mat-form-field class="estado-select-field" appearance="outline">
            <mat-select #selectEstado
              formControlName="estado"
              [compareWith]="compareEstados"
              (selectionChange)="onEstadoSelecionado($event.value)"
              disableRipple
              panelClass="localidades-select-panel">
              <mat-option [value]="null">
                <em>Nível Nacional</em>
              </mat-option>
              <mat-option 
                *ngFor="let estado of estados" 
                [value]="estado">
                {{ estado.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="cidade-select-field" appearance="outline">
            <mat-select #selectCidade
              formControlName="cidade"
              [compareWith]="compareCidades"
              (selectionChange)="onCidadeSelecionada($event.value)"
              disableRipple
              panelClass="localidades-select-panel">
              <mat-option [value]="null">
                <em>Todo o estado</em>
              </mat-option>
              <mat-option 
                *ngFor="let cidade of cidades" 
                [value]="cidade">
                {{ cidade.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field class="plano-educacional-select-field" appearance="outline">
            <mat-select #selectPlanoEducacional
              formControlName="planoEducacional"
              [compareWith]="comparePlanosEducacionais"
              (selectionChange)="onPlanoEducacionalSelecionado($event.value)"
              disableRipple
              panelClass="localidades-select-panel">
              <mat-option
                *ngFor="let plano of planosEducacionais"
                [value]="plano">
                {{ plano.label }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field *ngIf="mostrarSeletorEscolas" class="escola-select-field" appearance="outline">
            <mat-select #selectEscola
              formControlName="escola"
              [compareWith]="compareEscolas"
              (selectionChange)="onEscolaSelecionada($event.value)"
              disableRipple
              panelClass="localidades-select-panel">
              <mat-option [value]="null">
                <em>Todas as escolas do município</em>
              </mat-option>
              <mat-option
                *ngFor="let escola of escolas"
                [value]="escola">
                {{ escola.nomeInstituicao }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </form>

      <!-- Notas explicativas -->
      <div *ngIf="ehR2">
        <div class="notes-container">
          <p class="notes-title">Notas:</p>
          <p class="note-item">(*) No Plano Nacional de Educação, a simulação considera, conjuntamente, os dados de todas as redes estaduais e municipais do país.</p>
          <p class="note-item">(*) No Plano Estadual de Educação, a simulação considera, conjuntamente, os dados de todas as redes estaduais e municipais do estado selecionado.</p>
          <p class="note-item">(*) No Plano da rede estadual de educação, são considerados exclusivamente os dados da rede estadual selecionada.</p>
          <p class="note-item">(*) No Plano Municipal de Educação, a simulação considera, conjuntamente, os dados da rede estadual e municipal na localidade selecionada.</p>
          <p class="note-item">(*) No Plano da rede municipal de educação, são considerados exclusivamente os dados da rede municipal selecionada.</p>
        </div>
      </div>
      <div *ngIf="!ehR2">
        <div class="notes-container">
          <p class="notes-title">Notas:</p>
          <p class="note-item">(*) No Plano Nacional de Educação, a simulação considera, conjuntamente, os dados de todas as redes estaduais e municipais do país.</p>
          <p class="note-item">(*) No Plano Estadual de Educação, a simulação considera, conjuntamente, os dados de todas as redes estaduais e municipais do estado selecionado.</p>
          <p class="note-item">(*) No Plano da rede estadual de educação, são considerados exclusivamente os dados da rede estadual selecionada.</p>
          <p class="note-item">(*) No Plano da rede municipal de educação, são considerados exclusivamente os dados da rede municipal selecionada.</p>
        </div>
      </div>

      <!-- Botão Simular -->
      <div class="button-container">
        <button
          class="start-simulation-button px-4 py-3 bg-orange-400 border-0 rounded-xs flex items-center gap-2"
          (click)="onSimular()"
          [disabled]="carregandoEstados || carregandoCidades"
        >
          <span class="text-body-xlg text-regular text-gray-50">
            Simular
          </span>
          <img src="assets/icons/arrow-right.svg" alt="arrow-right">
        </button>
      </div>

    </div>
  </section>
</main>
